@if (!showCookieBlock) {
<div class="a-footer copyright">
    <div class="align-items-center">
        <div class="a-panel-wrapper p-4">
            <div class="a-pwc-logo-grid a-md ml-3"></div>
            <div>
                <ap-footer [content]="footerContent"></ap-footer>
            </div>
        </div>
    </div>
</div>
}
@if (showCookieBlock) {
<div class="a-footer cookieAcceptance">
    <div class="align-items-center">
        <div class="a-panel-wrapper p-3">
            <div>
                <ap-footer [content]="cookieAcceptanceContent"></ap-footer>
            </div>
            <div class="">
                <ap-button [label]="'I understand'" class="ap-mr-spacing-3" [btnType]="'primary'" (onClick)="iUnderstand()"></ap-button>
            </div>
        </div>
    </div>
</div>
}